export const PetState = Object.freeze({
  CELEBRATE: 'celebrate',
  HAPPY: 'happy',
  IDLE: 'idle',
  LEARNING: 'study',
  SLEEPING: 'sleep',
})

const PET_STATE_VALUES = new Set(Object.values(PetState))

export function normalizePetRuntimeState(state) {
  return PET_STATE_VALUES.has(state) ? state : PetState.IDLE
}

export function resolvePetRuntimeState({
  actionLoading = '',
  dropActive = false,
  moment = '',
  petState = '',
} = {}) {
  if (dropActive) return PetState.LEARNING
  if (moment === 'success') return PetState.CELEBRATE
  if (moment === 'feeding' || actionLoading === 'feed') return PetState.HAPPY
  if (moment === 'catching' || moment === 'analyzing') return PetState.LEARNING
  if (petState === 'success') return PetState.CELEBRATE
  if (petState === 'happy' || petState === 'feeding') return PetState.HAPPY
  if (petState === 'thinking' || petState === 'dragOver') return PetState.LEARNING
  if (petState === 'sleeping') return PetState.SLEEPING
  return PetState.IDLE
}
